import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { startTelemetry, stopTelemetry, trackScreen, trackClick } from '../lib/telemetry'
import { normalizeScreen, clickTarget } from '../lib/screenTracking'

/**
 * Подключение продуктовой телеметрии к приложению: экран из маршрута плюс
 * автосбор кликов. Разметка элементов не требуется — иначе метрика «сколько
 * нажимают» заработала бы только там, куда руки дошли расставить атрибуты.
 */
export function useTelemetry(getToken: () => string | null, active: boolean) {
  const location = useLocation()

  useEffect(() => {
    if (!active) return
    startTelemetry(getToken)

    const onClick = (e: MouseEvent) => {
      const target = clickTarget(e.target as Element | null)
      if (target) trackClick(target)
    }
    document.addEventListener('click', onClick, true)

    return () => {
      document.removeEventListener('click', onClick, true)
      stopTelemetry()
    }
    // getToken — стабильная функция чтения актуального токена, пересоздавать
    // подписки на её изменение не нужно.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [active])

  useEffect(() => {
    if (!active) return
    trackScreen(normalizeScreen(location.pathname))
  }, [location.pathname, active])
}
